import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/21.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Rodzina Hornów"     
        question="Co robisz?" 
            audio={audio}
        answers={{
            ans1: "Rozmawiasz z Hornem.",
            ans2: "Podchodzisz do kobiety.",    
        }}
        links={{
            link1: PAGES.p36,
            link2: PAGES.p37,
        }}
        content={
            <div>
                <ul>
                    <li>Pochwalony!</li>
                    <li>Dzień dobry, panie Horn, zostały wam jakieś rybki? Słyszałem, że łowiliście ostatnio? Wiozę dla was soczyste śliwki, w sam raz na deserek.</li>
                    <li>a, łowiłem, łowiliśmy. Wszystko klar, bierzemy.</li>
                    <li>Jak robota na starorzeczach?</li>
                    <li>
                    Idzie woda, będą ryby – odpowiada Horn, ale widać, że nie ma ochoty na dłuższe rozmowy. Kobieta w chuście – zdaje się, że Hornowa – wynosi z chaty kosz ryb.
                    </li>
                </ul>
            </div>
        }
        />
        
            );
}